<script lang="ts">
    import type {Px} from 'shared/ui-widgets/types';
    import {exists} from 'shared/utils/custom-utils';

    export let marginVertical: Px = '5px';
    export let marginOverride: string | null = null;
    export let width = 'auto';
</script>

<div class="kp-horizontal-separator"
     style:--margin="{exists(marginOverride) ? marginOverride : `${marginVertical} 0`}"
     style:--width="{width}"
     role="separator">
</div>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro-erp.less";

    .kp-horizontal-separator {
        clear: both;
        height: 1px;
        background-color: @themed-border-default;
        margin: var(--margin);
        width: var(--width);
    }
</style>